import React, {useEffect} from 'react';

import copyToClipboard from 'copy-to-clipboard';
import {useStore} from 'effector-react';

import {permissions$} from 'models/auth';

import {UserPermissionValue} from 'types';

export const useMatchMedia = (mediaQueryString: string) => {
    const [isMatched, setIsMatched] = React.useState(window.matchMedia(mediaQueryString).matches);

    React.useEffect(() => {
        const handleWindowResize = () => setIsMatched(window.matchMedia(mediaQueryString).matches);

        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, [mediaQueryString]);

    return isMatched;
};

export const useOutsideClick = (ref: any, callback: Function) => {
    useEffect(() => {
        function handleClickOutside(event: Event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback]);
};

export const useClipboard = (): ((text: string) => void) => (text: string) => {
    copyToClipboard(text);
};

export const usePermission = (permissions: UserPermissionValue[]) => {
    const currentPermissions = useStore(permissions$);

    return permissions.every((elem) => currentPermissions.includes(elem));
};
